import tools from './campaignTools.json';
import articles from './campaignArticles.json';
import comparison from './campaignComparison.json';
import config from './campaignConfig.json';
import { getCampaignEntries } from '../lib/campaignAvailability';
import { CONTENT_AS_OF } from '../lib/publication';

export const CAMPAIGN_PREVIEW = process.env.REACT_APP_CAMPAIGN_PREVIEW === 'true';
const entries = [
  ...tools,
  ...[...articles, ...comparison].map(post => ({ ...post, path: `/blogs/${post.slug}` })),
];
const available = getCampaignEntries(entries, config, { preview: CAMPAIGN_PREVIEW, asOf: CONTENT_AS_OF })
  .map(entry => ({ ...entry, noindex: CAMPAIGN_PREVIEW }));

const availablePaths = new Set(available.map(entry => entry.path));
const unavailablePaths = new Set(entries.map(entry => entry.path).filter(path => !availablePaths.has(path)));
const unavailableSlugs = new Set(entries.filter(entry => entry.slug && !availablePaths.has(entry.path)).map(entry => entry.slug));
const isUnavailable = to => typeof to === 'string' && unavailablePaths.has(to.split(/[?#]/)[0].replace(/\/+$/, '') || '/');

function resolveCampaignLinks(entry) {
  return {
    ...entry,
    ...(entry.body ? { body: entry.body.map(block => block.type === 'link' && isUnavailable(block.to)
      ? { type: 'p', text: `${block.before || ''}${block.text}${block.after || ''}` }
      : block) } : {}),
    ...(entry.links ? { links: entry.links.filter(link => !isUnavailable(link.to)) } : {}),
    ...(entry.relatedSlugs ? { relatedSlugs: entry.relatedSlugs.filter(slug => !unavailableSlugs.has(slug)) } : {}),
    ...(entry.cta && isUnavailable(entry.cta.to) ? { cta: undefined } : {}),
  };
}

export const CAMPAIGN_TOOLS = available.filter(entry => !entry.slug).map(resolveCampaignLinks);
export const CAMPAIGN_POSTS = available.filter(entry => entry.slug).map(resolveCampaignLinks);
